<template>
  <img v-bind:src="userAvatarSrc" v-bind:alt="userAvatarName" />
</template>

<script>
import { reactive } from 'vue'
export default {
  props: {
    userAvatarName: String
  },
  setup(props) {
    const avatars = reactive([
      {
        AvatarName: '男性1',
        AvatarSrc: require('@/assets/male_1.png')
      },
      {
        AvatarName: '男性2',
        AvatarSrc: require('@/assets/male_2.png')
      },
      {
        AvatarName: '男性3',
        AvatarSrc: require('@/assets/male_3.png')
      },
      {
        AvatarName: '男性4',
        AvatarSrc: require('@/assets/male_4.png')
      },
      {
        AvatarName: '男性5',
        AvatarSrc: require('@/assets/male_5.png')
      },
      {
        AvatarName: '男性6',
        AvatarSrc: require('@/assets/male_6.png')
      },
      {
        AvatarName: '男性7',
        AvatarSrc: require('@/assets/male_7.png')
      },
      {
        AvatarName: '男性8',
        AvatarSrc: require('@/assets/male_8.png')
      },
      {
        AvatarName: '女性1',
        AvatarSrc: require('@/assets/female_1.png')
      },
      {
        AvatarName: '女性2',
        AvatarSrc: require('@/assets/female_2.png')
      },
      {
        AvatarName: '女性3',
        AvatarSrc: require('@/assets/female_3.png')
      },
      {
        AvatarName: '女性4',
        AvatarSrc: require('@/assets/female_4.png')
      },
      {
        AvatarName: '女性5',
        AvatarSrc: require('@/assets/female_5.png')
      },
      {
        AvatarName: '女性6',
        AvatarSrc: require('@/assets/female_6.png')
      },
      {
        AvatarName: '女性7',
        AvatarSrc: require('@/assets/female_7.png')
      },
      {
        AvatarName: '女性8',
        AvatarSrc: require('@/assets/female_8.png')
      }
    ])
    const userAvatar = reactive(
      avatars.find(avatar => {
        return avatar.AvatarName === props.userAvatarName
      })
    )
    const userAvatarSrc = reactive(userAvatar.AvatarSrc)

    return {
      userAvatar,
      userAvatarSrc
    }
  }
}
</script>

<style></style>
